class OrderDetailOption {
  constructor({
    name,
    quantity,
    imageUrl
  }) {
    this.name = name
    this.quantity = quantity
    this.imageUrl = imageUrl
  }

  getName() {
    return this.name
  }

  getQuantity() {
    return this.quantity
  }

  getImageUrl() {
    return this.imageUrl
  }
}

export default OrderDetailOption

export const ofOrderDetailOption = (params = {}) => new OrderDetailOption(params)
